module.exports = __webpack_public_path__ + "static/media/anc2ru.7b19f8eb.pdf";